"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _react = require('react');
var _entity = require('shared/services/entity');


const EMPTY_MAP = {}






const useSelectedEntities = ({
  initialEntitiesMap,
  initialEntitiesList,
} = {}) => {
  const [selectedEntitiesMap, setSelectedEntitiesMap] =
    _react.useState(EMPTY_MAP)
  const filteredEntityKeysRef = _react.useRef.call(void 0, new Set())

  const onSelectEntity = _react.useCallback.call(void 0, 
    (e) => {
      filteredEntityKeysRef.current.delete(e.entityKey)
      setSelectedEntitiesMap(es => ({ ...es, [e.entityKey]: e }))
    },
    [setSelectedEntitiesMap],
  )

  const onRemoveEntity = _react.useCallback.call(void 0, 
    (key) => setSelectedEntitiesMap(map => ({ ...map, [key]: null })),
    [setSelectedEntitiesMap],
  )

  const onResetEntities = _react.useCallback.call(void 0, 
    () => setSelectedEntitiesMap(EMPTY_MAP),
    [setSelectedEntitiesMap],
  )

  const onFilterEntities = _react.useCallback.call(void 0, 
    (predicate) => setSelectedEntitiesMap(map => {
      let didDropEntity = false
      const entries = Object.entries(map).map(([rawKey, entity]) => {
        const key = rawKey 
        const keep = !!entity && predicate(entity)
        if (keep) filteredEntityKeysRef.current.delete(key)
        else {
          filteredEntityKeysRef.current.add(key)
          if (entity) didDropEntity = true
        }
        return [key, keep ? entity : null]
      })
      return didDropEntity
        ? Object.fromEntries(entries) 
        : map
    }),
    [setSelectedEntitiesMap],
  )

  const selectedEntitiesList = _react.useMemo.call(void 0, 
    () => _entity.entityMapToList.call(void 0, selectedEntitiesMap),
    [selectedEntitiesMap],
  )

  _react.useEffect.call(void 0, 
    () => {
      const initialMap = initialEntitiesMap || _entity.entityListToMap.call(void 0, initialEntitiesList)
      const allowedInitialMap = Object.fromEntries(
        Object.entries(initialMap || {}).filter(([rawKey]) =>
          !filteredEntityKeysRef.current.has(rawKey ),
        ),
      ) 

      if (Object.keys(allowedInitialMap).length) {
        setSelectedEntitiesMap(map => ({ ...map, ...allowedInitialMap }))
      }
    },
    [initialEntitiesMap, initialEntitiesList],
  )

  return {
    selectedEntitiesMap,
    selectedEntitiesList,
    onSelectEntity,
    onRemoveEntity,
    onResetEntities,
    onFilterEntities,
  }
}

exports. default = useSelectedEntities
